logit.classes.TableEditableItem = class TableEditableItem {
    constructor($editable, value) {
        this._pk = resolvePrimaryKey($editable);
        this._wasSelected = $editable.hasClass('editable-unsaved');
        this._tableId = $editable.parents('table').attr('id');
        this._columnIndex = $editable.data('index');
        this._dataAttributes = getDataAttributes($editable);
        this._value = value;

        function getDataAttributes($editable) {
            var node = $editable[0];
            var attributeNodeArray = Array.prototype.slice.call(node.attributes);

            return attributeNodeArray.reduce(function (attrs, attribute) {
                if (attribute.name.includes('data-')) {
                    attrs[attribute.name] = attribute.value;
                }
                return attrs;
            }, {});
        }

        function resolvePrimaryKey($editable) {

            if ($editable.attr('pk') !== '') {
                return $editable.attr('pk');
            }

            var editableData = $editable.data('editable');

            if (typeof editableData !== 'undefined' && typeof editableData.options.pk  !== 'function') {
                return editableData.options.pk;
            }

            if (typeof editableData !== 'undefined' && typeof editableData.options.pk === 'function') {
                return editableData.options.pk.apply($editable);
            }
        }
    }

    get pk() {
        return this._pk;
    }

    get wasSelected() {
        return this._wasSelected;
    }

    get columnIndex() {
        return this._columnIndex;
    }

    get dataAttributes() {
        return this._dataAttributes;
    }

    get value() {
        return this._value;
    }

    get tableId() {
        return this._tableId;

    }

    get key() {
        //return [this.tableId, this.pk, this.columnIndex, Object.entries(this.dataAttributes).toString()].join('_');
        return [this.tableId, this.pk, this.columnIndex].join('_');
    }
}